import React from "react";
import { Background } from "./Wrapper.components";

const Wrapper = ({ children }) => <Background>{children}</Background>;

export default Wrapper;
